import { mainApiAxios as axios } from '@/plugins/axios'
import { useStripHtml } from '@/helpers/common.js'

export default {

    listQuestions() {
        return axios.get('questionsbanks')
    },

    
    addQuestion(questionObj) {
        questionObj.questionAr = useStripHtml(questionObj.questionAr)
        questionObj.questionEn = useStripHtml(questionObj.questionEn)
        return axios.post('questionsbanks', questionObj)
    },
    loadQuestion(questionId) {
        return axios.get(`questionsbanks/${questionId}`)
    },
    deleteQuestion(questionId) {
        return axios.post(`questionsbanks/deleteQuestionBank/${questionId}`)
    }
}